import {
  transformDateToLocalDateString,
} from "helpers";
import { FleetDocumentRow} from "services/api/fleet/vehicles/documents/types";
import { PictureIcon } from "ui/components/Pictures";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const FLEET_VEHICLE_DOCUMENT_SEARCH_COLUMNS = (
  t: (key: string) => string,
  onDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => {
  return [
    {
      title: "",
      field: "image",
      type: ColumnTypes.custom,
      render: (row: FleetDocumentRow) => {
        const uploads = row.childRows ?? [];

        // Bez priloga → fallback inicijal tipa dokumenta.
        if (uploads.length === 0) {
          return (
            <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
              <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                {row.documentType?.name.toString().charAt(0).toUpperCase()}
              </span>
            </div>
          );
        }

        // 1+ priloga → PictureIcon u stack modu auto-razrješava ikonu iz
        // ekstenzije (slika → thumbnail; dokument → file-type SVG). Klik
        // otvara file u novom tabu. Za >3 prikazuje se "+N" badge.
        return (
          <PictureIcon
            maxVisible={3}
            items={uploads.map((u) => ({
              id: u.id,
              url: u.url,
              fileName: u.originalFileName,
              tooltip: u.originalFileName,
            }))}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.document.search.name",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div>
            <div className="text-md">{row.name}</div>
            <div className="text-sm font-light text-slate-500">{row.documentType.name}</div>
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.document.search.description",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-sm font-light text-slate-500">{row.description}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.document.search.createdon",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md">
            {transformDateToLocalDateString(row.created)}
          </div>
        );
      },
    },
    {
      title: "",
      key: "document_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              onClick={(e) => onDeleteClick(e, row.id)}
            >
              Obriši
            </ButtonMenuItem>
          </ButtonMenu>
        );
      },
    },
  ];
};


